// 2020-06-27
export { ResetPasswordComponent } from './reset-password.component';
